require([
    'services',
    'jquery',
    'semantic',
    'ch_header',
    'ch_form_validation',
    'ch_semantic_responsive',
    'ch_welcome_overlay'
], function () {

    // Local variables
    var $emails = $('#emails');
    var $nameSection = $('#name_section');
    var $name = $('#name');
    var $referralLink = $('#referral_link');
    var $copyButton = $('#copy-button');

    function referralSuccess(res) {
        if (res.success) {
            $emails.val('');
            $nameSection.hide();

            if(!res.sent_emails) {
                var ModalWindowReferralConfirmationFailureObj = new ModalWindowReferralConfirmationFailure();
                ModalWindowReferralConfirmationFailureObj.show({
                    onShow: function () {
                        ga(
                            'send',
                            'event',
                            'Email Capture',
                            'Referral Program - Overlay',
                            'Email Captured - Referral Page',
                            { nonInteraction: false }
                        );

                        var confirmationWindow = ModalWindowReferralConfirmationFailureObj.window;
                        confirmationWindow.find('.friends').html(res.friends);

                        if(res.pre_existing_emails_count < 2) {
                            confirmationWindow.find('#know').html('knows');
                            confirmationWindow.find('#have').html('has');
                        } else {
                            confirmationWindow.find('#know').html('know');
                            confirmationWindow.find('#have').html('have');
                        }
                    },
                    autofocus: false
                });
            } else {
                var ModalWindowReferralConfirmationObj = new ModalWindowReferralConfirmation();
                ModalWindowReferralConfirmationObj.show({
                    onShow: function () {
                        ga(
                            'send',
                            'event',
                            'Email Capture',
                            'Referral Program - Overlay',
                            'Email Captured - Referral Page',
                            { nonInteraction: false }
                        );

                        var confirmationWindow = ModalWindowReferralConfirmationObj.window;
                        confirmationWindow.find('#friends').html(res.friends);

                        if (res.pre_existing_emails) {
                            confirmationWindow.find('#preExistingEmails').html(res.pre_existing_emails);
                        } else {
                            confirmationWindow.find('#preExistingEmails').html('');
                        }
                    },
                    autofocus: false
                });
            }

        } else {
            swal({
                title: res.error,
                type: "error",
                confirmButtonText: "Ok"
            });
        }
    }

    function initEventHandlers() {
        var ModalWindowRegisterObj = new ModalWindowRegister();

        // Display sign-up modal if user not logged in
        $('#sign-up').on('click', function() {
            ModalWindowRegisterObj.show();
        });

        // GA event when clicking on referral modal share links
        $('.social-share a').on('click', function() {
            ga(
                'send',
                'event',
                'Social ' + $(this).attr('title') + ' Referral',
                'Referral social share clicked',
                null,
                { nonInteraction: false }
            );
        });

        $copyButton.on('click', function (e) {
            e.preventDefault();
            $referralLink.select();
            document.execCommand('copy');
        });
    }

    function initForm() {
        // Form validator and submit handler
        var formValidator = CH.validate('form_Referral', {
            submitHandler: function () {
                $.ajax({
                    url: '/user/Account/referral-post',
                    type: 'POST',
                    async: false,
                    dataType: 'json',
                    data: {
                        emails: $emails.val(),
                        referral_link: $referralLink.val(),
                        name: $name.val()
                    },
                    success: referralSuccess
                });
            }
        });

        $copyButton.html('Select');
    }

    $(function () {
        initEventHandlers();
        initForm();

        // Landing page GA event
        ga(
            'send',
            'event',
            'Email Capture',
            'Referral Program - Page',
            'Page Opened - Referral Page',
            { nonInteraction: false }
        );
    });
});
